'use client'
import { ArgentX } from './wallets/argentx.js';
import { Braavos } from './wallets/braavos.js';
import { ArgentXMobile } from './wallets/argentxMobile.js';
import { ArgentXWeb } from './wallets/argentxWeb.js';
import { Bitget } from './wallets/bitget.js';
import { Okx } from './wallets/okx.js';
import { MetaMask } from './wallets/metamask.js';
import '@dynamic-labs/rpc-provider-starknet';

/* eslint-disable @typescript-eslint/no-unused-vars */
const StarknetWalletConnectors = (props) => [
    ArgentX,
    Braavos,
    ArgentXMobile,
    ArgentXWeb,
    Okx,
    Bitget,
    MetaMask,
];

export { StarknetWalletConnectors };
